type TXCenterBadgeProps = {
  txCenterCode: string;
};

export const TXCenterBadge = ({ txCenterCode }: TXCenterBadgeProps) => {
  return (
    <div className="w-8 h-8 bg-base-90 rounded-[10px] flex items-center justify-center">
      <span className="text-base-10 text-[9px] font-semibold">{txCenterCode}</span>
    </div>
  );
};
